<template>
    <section>

        <div class="page">
            <div>
                <h2>Lost and stolen phones</h2>
                <p>In the unfortunate case that your phone becomes lost or stolen, we can help make sure that no one can
                    use
                    your ToTok account.</p>
                <h3>What to do</h3>
                <ol>
                    <li>Lock your SIM card.</li>
                    <ul>
                        <li>You should call your mobile provider as soon as possible to lock your SIM card. It will then
                            not be
                            possible to verify the account on that phone again, as you must be able to receive SMS or
                            phone calls to
                            verify an account.
                        </li>
                    </ul>
                    <li>Use a new SIM card with the same number to activate ToTok on your new phone.</li>
                    <ul>
                        <li>This is the fastest way to deactivate your account on the stolen phone. ToTok can only be
                            activated
                            with one phone number on one device at a time.
                        </li>
                    </ul>
                </ol>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
